import { CIPage, ISearchPage } from '@/types/FmsTypes'
import { ciHttpRequest } from "@/utils/CiHttpRequest";
import { BillDetailResult, BillTotalResult } from './settleTypes'

class SettleService {

    async total(searchVo: any) {
        const apiUrl = '/yh-franchisee/franchiseeBill/list'
        return await ciHttpRequest.post<CIPage<BillTotalResult>>(apiUrl, searchVo)
    }

    async detail(searchVo: any) {
        const apiUrl = '/yh-franchisee/order/bill_platform_list'
        return await ciHttpRequest.post<CIPage<BillDetailResult>>(apiUrl, searchVo)
    }

    async one(id: string) {
        const apiUrl = `/yh-franchisee/franchiseeBill/one/${id}`
        return await ciHttpRequest.get<any>(apiUrl)
    }

    async audit(params: any) {
        const apiUrl = '/yh-franchisee/franchiseeBill/audit'
        return await ciHttpRequest.post<boolean>(apiUrl, params);
    }

    async deleteInvoice(id: string) {
        const apiUrl = `/yh-franchisee/franchiseeBillInvoice/delete/${id}`
        return await ciHttpRequest.get<any>(apiUrl)
    }

}

export const settleService = new SettleService()

